enum ICON_TYPE {
  PPE = 'PPE',
  GHS = 'GHS',
  ISO = 'ISO',
}

export default ICON_TYPE;
